'use strict';

module.exports =
'<li class="ad-universalnav-icons" adu-tooltip="<%= tooltipLabel %>" adu-tooltip-position="bottom">' +
		'<a home-link="true" class="ad-icon-link" href="<%= href %>">' +
			'<i class="ad-icon-home"></i>' +
		'</a>' +
'</li>';



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/templates/icons/home-icon.tpl.js
// module id = 41
// module chunks = 0